import { apiClient } from '@api/api-client'
import { useAuth } from '@auth/use-auth'
import { AGENT_BILL_PAY_PATH } from '@pages/bill-pay/constants'
import { useQueryClient, useQuery } from '@tanstack/react-query'

export const CrumbLabel = ({ docId }) => {
  const { orgId } = useAuth()
  const queryClient = useQueryClient()
  const queryKey = ['display-name', docId, orgId]
  const queryState = queryClient.getQueryState(queryKey)
  const inFlight =
    queryState?.fetchStatus === 'fetching' || queryState?.status === 'pending'
  const hasData = !!queryClient.getQueryData(queryKey)
  const isAskAiPage = docId === 'ask-ai'
  const isBillPayPage = docId === AGENT_BILL_PAY_PATH.slice(1)

  const { data } = useQuery({
    queryKey,
    queryFn: async () =>
      await apiClient.get('/documents/display_name', {
        params: { doc_id: docId },
      }),
    enabled:
      Boolean(docId) && !hasData && !inFlight && !isAskAiPage && !isBillPayPage,
    placeholderData: () => {
      const entries = queryClient.getQueriesData({
        queryKey: ['documents', orgId],
      })
      for (const [, d] of entries) {
        const row = d?.data?.find?.((r) => r?.doc_id === docId)
        if (row) return { display_name: row.display_name, date: row.date }
      }
      const cached = queryClient.getQueryData(queryKey)
      return cached ?? undefined
    },
  })

  if (isAskAiPage) {
    return 'Ask AI'
  }

  if (isBillPayPage) {
    return 'Bill Pay'
  }

  return <>{data?.display_name ?? docId}</>
}
